import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["newButton"]

  connect() {
    document.addEventListener("turbo:frame-render", this.handleFrameRender)
  }

  disconnect() {
    document.removeEventListener("turbo:frame-render", this.handleFrameRender)
  }

  handleFrameRender = (event) => {
    if (event.target.id === "new_user_form" && event.target.innerHTML.trim() !== "") {
      this.newButtonTarget.classList.add("pointer-events-none", "opacity-50")
    } else if (event.target.id === "new_user_form" && event.target.innerHTML.trim() === "") {
      this.newButtonTarget.classList.remove("pointer-events-none", "opacity-50")
    }
  }
}